// extracted by mini-css-extract-plugin
export default {"confirmation":"card-success_confirmation__jsnYc","container":"card-success_container__JT7Ak"};